import { render, staticRenderFns } from "./Cara.vue?vue&type=template&id=e488f87e&scoped=true&"
import script from "./Cara.vue?vue&type=script&lang=js&"
export * from "./Cara.vue?vue&type=script&lang=js&"
import style0 from "./Cara.vue?vue&type=style&index=0&id=e488f87e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e488f87e",
  null
  
)

export default component.exports